<mat-form-field [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <mat-select [value]="value" (selectionChange)="onSelectionChange($event?.value);" [disabled]="disabled" [required]="required" multiple>
    <mat-select-trigger>
      {{ value ? getOption(value?.[0]) : '' }}
      <span *ngIf="value?.length > 1">
        (+{{ value.length - 1 }} {{ value?.length === 2 ? 'other' : 'others' }})
      </span>
    </mat-select-trigger>
    <mat-optgroup *ngFor="let optGroup of options" [label]="optGroup?.label" [disabled]="optGroup?.disabled ?? null">
      <mat-option *ngFor="let item of optGroup?.group" [value]="item?.value">
        {{ item?.name }}
      </mat-option>
    </mat-optgroup>
  </mat-select>
  <ng-content select="[validation]"></ng-content>
  <ng-container *ngIf="validator && formSubmit">
    <ng-container *ngFor="let error of formControl?.errors | keyvalue;">
      <mat-error *ngIf="error?.value">
        <em class="fas fa-exclamation-circle mr-2"></em>
        {{ generalService?.getErrorMessage(label, error?.key) }}
      </mat-error>
    </ng-container>
  </ng-container>
</mat-form-field>